/**
 * Time helpers. The key trick is `bucketedNow()` — it returns
 * Date.now() rounded down to a 5-minute boundary, so a React component
 * that uses it inside a TanStack Query `queryKey` doesn't re-fetch
 * on every render (which would cause an infinite re-render loop).
 *
 * Without this, the chain is:
 *   render → Date.now() changes → queryKey changes →
 *   useQuery refetches → state updates → render → ...
 * Burned by this on first dashboard rebuild. See git
 * `git log --grep="infinite loop"` for the incident.
 */
const BUCKET_MS = 5 * 60_000;

export function bucketedNow(): number {
  return Math.floor(Date.now() / BUCKET_MS) * BUCKET_MS;
}

export function thirtyDayWindow(): { from: number; to: number } {
  const to = bucketedNow();
  return { from: to - 30 * 24 * 60 * 60 * 1000, to };
}

export function sevenDayWindow(): { from: number; to: number } {
  const to = bucketedNow();
  return { from: to - 7 * 24 * 60 * 60 * 1000, to };
}

export function oneDayWindow(): { from: number; to: number } {
  const to = bucketedNow();
  return { from: to - 24 * 60 * 60 * 1000, to };
}
